<ng-container *ngIf="dataLoaded">
  <finra-card-wrapper role="status" aria-live="polite">
    <finra-card show-expand-control="false" expanded="true" show-menu-control="false">
      <h1>MU3 Submitted</h1>
      <p>Your MU3 has been submitted.</p>
      <h2>Next Steps</h2>
      <ul>
        <li>
          An email will be sent to {{ notificationEmail || 'your registered email' }} once the submission has finished
          processing along with any additional important tasks for you to complete.
        </li>
      </ul>
      <div class="spacer"></div>
      <finra-button (click)="finishRouting()" aria-label="Finish and return to Work Management">Finish</finra-button>
    </finra-card>
  </finra-card-wrapper>
</ng-container>

<div class="form-content">
  <ng-container *ngIf="!dataLoaded">
    <div class="center-page">
      <finra-spinner [isBackdrop]="false"></finra-spinner>
    </div>
  </ng-container>
</div>
